import React from 'react'
import { Link } from 'gatsby'
import Layout from '../components/Layout'
import Seo from '../components/Seo'
import Container from '../components/Container'
import Banner from '../components/BannerAlternate'

import tw from 'twin.macro'

import { sectionHeading, Section } from '../styles/ui'

function Sitemap() {

    const siteMap = [
        { pageTitle: 'Home', pageUrl: '/' },
        { pageTitle: 'Need for Effective Opioid Blockade', pageUrl: '/disease-risks' },
        {
            subjectTitle: 'Pharmacology',
            pages: [
                { pageTitle: <>Importance of 2+ ng/mL and  &mu;ORO</>, pageUrl: '/pharmacology/2-ng-ml' },
                { pageTitle: <>Targeting &mu;OR Is Critical</>, pageUrl: '/pharmacology/targeting-receptors' },
                { pageTitle: 'Continuous Buprenorphine Delivery', pageUrl: '/pharmacology/buprenorphine-delivery' },
                {
                    pageTitle: 'Long-lasting Plasma Levels',
                    pageUrl: '/pharmacology/plasma-levels',
                },
            ],
        },
        {
            subjectTitle: 'Efficacy & Safety',
            pages: [
                {
                    pageTitle: 'Hydromorphone Challenge',
                    pageUrl: '/efficacy/hydromorphone-challenge',
                },
                { pageTitle: 'Phase 3 Study', pageUrl: '/efficacy/phase-3-study' },
                { pageTitle: 'Rapid Initiation', pageUrl: '/efficacy/treatment-initiation' },
                { pageTitle: 'Safety', pageUrl: '/efficacy/clinical-safety' },
            ],
        },
        { pageTitle: 'Dosing & Administration', pageUrl: '/dosing-administration' },
        { pageTitle: 'Patient Considerations', pageUrl: '/patient-considerations' },
        {
            subjectTitle: 'Support & Resources',
            pages: [
                { pageTitle: 'For Your Patients', pageUrl: '/patient-access' },
                { pageTitle: 'For Your Practice', pageUrl: '/practice' },
                { pageTitle: 'Informational Resources', pageUrl: '/resources' },
                { pageTitle: 'FAQs', pageUrl: '/faqs' },
            ],
        },
        { pageTitle: <>Provide SUBLOCADE&reg;</>, pageUrl: '/list-your-practice#list-your-practice' },
        { pageTitle: 'Contact a Representative', pageUrl: '/contact-a-rep' },
    ]

    const titleStyle = tw`text-grey antialiased tracking-[0.188rem] uppercase text-base font-medium leading-6 block mb-1 lg:(tracking-[3px] text-lg mb-2)`
    const listStyle = tw`mb-30 lg:(mb-7 last:mb-0)`
    const linkStyle = tw`text-dark-cyan antialiased  underline text-lg font-medium leading-6 tracking-[0.005rem] lg:(text-lg) hover:text-dark-cyan`

    return (
        <Layout skeletonJobcode='P-BAG-US-01755v3 Apr 2026'>
            <Banner tw="[&_[data-kfs='banner-container']]:(hidden) xl:(hidden)" />
            <Container>
                <Section tw='pt-30 lg:(py-100)'>
                    <h1 css={[sectionHeading, tw`text-left`]}>Sitemap</h1>
                    <ul>
                        {siteMap.map((item, i) => {
                            return !item.subjectTitle ? (
                                <li css={listStyle} key={item.pageTitle}>
                                    <Link css={linkStyle} to={item.pageUrl}>
                                        {item.pageTitle}
                                    </Link>
                                </li>
                            ) : (
                                <li key={item.subjectTitle}>
                                    <span css={titleStyle}>
                                        {item.subjectTitle}
                                    </span>
                                    <ul tw="pl-5 mb-30 lg:(pl-6 mb-7)">
                                        {item.pages &&
                                            item.pages.map((page) => {
                                                return (
                                                    <li key={`page-${page.pageTitle}`} tw="block mb-[0.875rem] lg:(mb-2)">
                                                        <Link
                                                            css={linkStyle}
                                                            to={page.pageUrl}
                                                        >
                                                            {page.pageTitle}
                                                        </Link>
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                </li>
                            )
                        })}
                    </ul>
                </Section>
            </Container>
        </Layout>
    )
}

export const Head = () => <Seo title="Sitemap | SUBLOCADE® (buprenorphine extended-release) HCP" description="Find SUBLOCADE clinical studies, safety profile, dosing, and more helpful resources. See Safety Info, PI, & Boxed Warning." />

export default Sitemap

